import React from 'react';
import PropTypes from "prop-types";
import {useDispatch, useSelector} from "react-redux";
import {accessConstants, authUtils, UnpauseStreamAction, ReloadListAction} from "mindsets-js-sdk";

const ResumeButton = function ({item}) {
    const dispatch = useDispatch();
    const me = useSelector(state => state.me);
    if (authUtils.iCan(me, [accessConstants.PERMISSION_CAN_MANAGE_ALL_STREAMS]) && 'paused' === item.status) {
        return (
            <button className='button' onClick={event => {
                event.preventDefault();
                dispatch(UnpauseStreamAction(item.id)).then(() => dispatch(ReloadListAction(true, 'streams')));
            }}>Resume</button>
        );
    }

    return null;
}

ResumeButton.propTypes = {
    item: PropTypes.shape({
        id: PropTypes.number.isRequired,
        status: PropTypes.string.isRequired
    }).isRequired
};

export default ResumeButton;
